import { G as e, J as t, K as n, Q as r, X as i, d as a, ht as o, i as s, m as c, n as l, p as u, q as d, s as f, t as p, u as m } from "./chunk-client-CZP0uvho.js";
import { t as h } from "./chunk-Configure-CU2Fb_ZQ.js";
import { a as g, c as _, d as v, g as y, i as b, l as x, m as S, n as C, o as w, p as T, r as E, s as D, t as O, u as k } from "./chunk-routing-my0BK4te.js";
//#region src/lib/search/PromotedFacets.tsx
e();
var { indexName: A } = o, j = 240;
function M({ label: e, count: r, children: a }) {
	let [o, s] = i(!1), [c, l] = i(!1), u = t(null), p = d();
	return n(() => {
		if (!o) return;
		let e = (e) => {
			u.current?.contains(e.target) || s(!1);
		}, t = (e) => {
			e.key === "Escape" && s(!1);
		};
		return document.addEventListener("pointerdown", e), document.addEventListener("keydown", t), () => {
			document.removeEventListener("pointerdown", e), document.removeEventListener("keydown", t);
		};
	}, [o]), /* @__PURE__ */ f("li", {
		ref: u,
		className: "relative shrink-0",
		children: [/* @__PURE__ */ f("button", {
			type: "button",
			"aria-expanded": o,
			"aria-controls": p,
			onClick: () => {
				let e = u.current?.getBoundingClientRect().left ?? 0;
				l(e + j > window.innerWidth), s((e) => !e);
			},
			"data-active": r > 0 ? "" : void 0,
			className: "btn btn--pill data-active:border-brand-darkest flex items-center gap-2.5 px-4 py-1.5 text-sm whitespace-nowrap",
			children: [r > 0 ? `${e} (${r})` : e, /* @__PURE__ */ f("span", {
				"aria-hidden": "true",
				className: `size-1.5 border-r border-b border-current transition-transform ${o ? "translate-y-0.5 -rotate-135" : "-translate-y-0.5 rotate-45"}`
			})]
		}), o && /* @__PURE__ */ f("div", {
			id: p,
			role: "group",
			"aria-label": e,
			className: `border-brand-light absolute top-full z-40 mt-2 max-h-80 w-60 overflow-y-auto rounded-sm border bg-white px-3 py-2 shadow-lg ${c ? "right-0" : "left-0"}`,
			children: a
		})]
	});
}
function N({ options: e, type: t, onToggle: n }) {
	let r = d();
	return /* @__PURE__ */ f("ul", {
		className: "flex flex-col",
		children: e.map((e) => /* @__PURE__ */ f("li", {
			className: "flex",
			children: /* @__PURE__ */ f("label", {
				className: `hover:text-brand-darker flex w-full cursor-pointer items-center gap-2 py-1 ${e.isSelected ? "text-brand-darkest" : "text-brand-dark"}`,
				children: [/* @__PURE__ */ f("input", {
					type: t,
					name: t === "radio" ? r : void 0,
					className: "accent-brand-dark-warm size-4 shrink-0 cursor-pointer",
					checked: e.isSelected,
					onChange: () => n(e),
					onClick: () => {
						t === "radio" && e.isSelected && n(e);
					}
				}), /* @__PURE__ */ f("span", {
					className: "p",
					children: e.label
				})]
			})
		}, e.value))
	});
}
function P() {
	let { results: e, indexUiState: t } = a(), n = r(b), { filters: i } = window.generalStrings.search, { items: o, refine: s } = y({
		attribute: "vendor",
		limit: 100,
		sortBy: _
	}), { items: c, refine: l } = y({
		attribute: T,
		limit: 500,
		sortBy: ["name:asc"]
	}), u = k(), d = v(), p = (e, t) => {
		t.length !== 0 && window.aa?.("clickedFilters", {
			eventName: "Promoted Filter Clicked",
			index: A,
			filters: t.map((t) => `${e}:${t}`)
		});
	}, m = (e, t, r) => {
		n(), r.isSelected || p(e, [r.value]), t(r.value);
	}, h = o.length > 1, g = e?.renderingContent?.facetOrdering?.values?.["transformed_data.family"]?.order ?? [], C = o.length === 1 && c.length > 1, w = d.options.length > 1, E = u.options.length > 1;
	if (!h && !C && !w && !E) return null;
	let O = (e, t) => t.map((t) => ({
		value: t.value,
		label: x(e, t.label),
		isSelected: t.isRefined
	}));
	return /* @__PURE__ */ f("ul", {
		className: "flex flex-wrap gap-2",
		children: [
			h && /* @__PURE__ */ f(M, {
				label: i.brand,
				count: o.filter((e) => e.isRefined).length,
				children: /* @__PURE__ */ f(N, {
					type: "checkbox",
					options: O("vendor", o),
					onToggle: (e) => m("vendor", s, e)
				})
			}),
			C && /* @__PURE__ */ f(M, {
				label: i.collection,
				count: c.filter((e) => e.isRefined).length,
				children: /* @__PURE__ */ f(N, {
					type: "checkbox",
					options: O("transformed_data.family", S(c, g)),
					onToggle: (e) => m("transformed_data.family", l, e)
				})
			}),
			w && /* @__PURE__ */ f(M, {
				label: i.price,
				count: +!!t.range?.[D],
				children: /* @__PURE__ */ f(N, {
					type: "radio",
					options: d.options.map((e) => ({
						...e,
						isSelected: e.value === d.activeValue
					})),
					onToggle: (e) => {
						n(), d.select(e.isSelected ? "" : e.value);
					}
				})
			}),
			E && /* @__PURE__ */ f(M, {
				label: i.caseSize,
				count: u.options.filter((e) => e.isSelected).length,
				children: /* @__PURE__ */ f(N, {
					type: "checkbox",
					options: u.options,
					onToggle: (e) => {
						n(), p("meta.custom.case_size", u.toggle(e.value));
					}
				})
			})
		]
	});
}
//#endregion
//#region src/entry/collection-algolia.tsx
e();
var { appId: F, searchKey: I, indexName: L } = o, R = "shopify", z = l(F, I), B = {
	router: c({
		cleanUrlOnDispose: !1,
		push: C
	}),
	stateMapping: {
		stateToRoute(e) {
			let t = e[L]?.page;
			return {
				...O(e[L]),
				page: t && t > 1 ? String(t) : void 0
			};
		},
		routeToState(e) {
			let t = Number(e.page);
			return { [L]: {
				...E(e),
				page: t > 1 ? t : void 0
			} };
		}
	}
};
function V({ onReady: e, onError: r }) {
	let { status: i } = a({ catchError: !0 }), o = t(!1), s = t(!1);
	return n(() => {
		if (i === "loading" || i === "stalled") {
			o.current = !0;
			return;
		}
		o.current && !s.current && (i === "idle" ? (s.current = !0, e()) : i === "error" && (s.current = !0, r()));
	}, [
		i,
		e,
		r
	]), null;
}
function H({ handle: e, title: t, productsPerPage: n, gridInserts: r, onReady: i, onError: a }) {
	return /* @__PURE__ */ f(u, {
		searchClient: z,
		indexName: L,
		routing: B,
		children: [
			/* @__PURE__ */ f(m, {}),
			/* @__PURE__ */ f(V, {
				onReady: i,
				onError: a
			}),
			/* @__PURE__ */ f(h, {
				filters: `collections:"${e}"`,
				hitsPerPage: n
			}),
			/* @__PURE__ */ f(s.Provider, {
				value: t,
				children: /* @__PURE__ */ f(g.Provider, {
					value: r,
					children: /* @__PURE__ */ f(w, {
						showPrevious: !0,
						collectionLayout: !0,
						promoted: /* @__PURE__ */ f(P, {})
					})
				})
			})
		]
	});
}
async function U(e, t) {
	try {
		let n = new URL(window.location.href);
		n.searchParams.set("view", R);
		let r = await fetch(n).then((e) => e.text()), i = new DOMParser().parseFromString(r, "text/html").getElementById("collection");
		if (!i) throw Error("No #collection in Shopify fallback");
		e.unmount(), document.getElementById("collection-algolia-skeleton")?.remove(), t.replaceWith(i);
	} catch (e) {
		console.error("Algolia collection fallback failed", e);
	}
}
function W() {
	return [...document.querySelectorAll("template[data-grid-insert]")].map((e) => ({
		kind: e.dataset.gridInsert === "small" ? "small" : "row",
		placement: Number(e.dataset.placement),
		html: e.innerHTML
	})).filter((e) => e.placement > 0);
}
function G() {
	let e = document.getElementById("collection-algolia"), t = e?.dataset.collectionHandle;
	if (!e || !t) return;
	let n = p.createRoot(e);
	n.render(/* @__PURE__ */ f(H, {
		handle: t,
		title: e.dataset.collectionTitle ?? null,
		productsPerPage: Number(e.dataset.productsPerPage) || 16,
		gridInserts: W(),
		onReady: () => {
			document.getElementById("collection-algolia-skeleton")?.remove(), e.classList.remove("hidden");
		},
		onError: () => U(n, e)
	}));
}
G();
//#endregion
